export const FEATURE_FLAGS = {
  HAVING_FILTERS: false,
  WINDOW_FUNCTIONS: false,
  PIVOT_TABLE: false,
  PERIOD_COMPARISON: false,
  CONDITIONAL_FORMATTING: false,
} as const;
